<template>
  <div>
    <!-- 리스트 영역 시작 -->
    <div class="d-2304" v-if="filterdList && filterdList.length > 0">
      <HistoryListItem v-for="(item, i) in filterdList" :key="i" :item="item" :filter="filter" />
    </div>
    <div v-else-if="initLoading || summaryLoading">
      <p class="color--gray-60 font-size--16 my-16 py-16 text-center font-weight-bold">
        불러오는 중입니다.
      </p>
    </div>
    <div v-else-if="!isLoadable">
      <p class="color--gray-60 font-size--16 mt-16 pt-16 text-center font-weight-bold">
        정산 내역이 없습니다.
      </p>
    </div>
    <!-- 리스트 영역 끝 -->

    <!-- 더보기 버튼 시작 -->
    <div
      v-if="!summaryLoading && isLoadable"
      v-intersect.quiet="{
        handler: loadSummarys,
        options: {
          threshold: 1.0,
        },
      }"
      class="mt-12"
      style="padding-bottom: 56px"
    >
      <v-btn
        block
        large
        elevation="0"
        color="white"
        :loading="summaryLoading"
        @click="loadSummarys"
        class="white"
      >
        더보기
      </v-btn>
    </div>
    <v-btn
      v-else-if="summaryLoading && filterdList && filterdList.length > 0"
      block
      large
      elevation="0"
      color="white"
      :loading="true"
    />
    <!-- 더보기 버튼 끝 -->
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import HistoryListItem from './HistoryListItem.vue'

export default {
  components: { HistoryListItem },
  props: ['filter'],
  data() {
    return {
      initLoading: false,
      summaryLoading: false,
      baseEndDate: null,
    }
  },
  computed: {
    ...mapState('auth', ['me']),
    ...mapState('bnpl', ['summarys', 'limitDates']),
    filterdList() {
      const summarys = this.summarys?.results

      if (!this.filter || this.filter === 'all') return summarys

      return summarys.filter((e) => e[this.filter].length > 0)
    },
    isLoadable() {
      if (!this.baseEndDate || !this.limitDates) return false
      return !this.$moment(this.baseEndDate).isBefore(this.limitDates.limitStartDate)
    },
    hasStoredSummarys() {
      return this.summarys?.results?.length > 0
    },
  },
  methods: {
    ...mapActions('auth', ['getMe']),
    ...mapActions('bnpl', ['getSummarys', 'getSummarysAppend', 'getLimitDates']),
    ...mapMutations('bnpl', ['setSummarysBaseEndDate']),

    getPageLimitDates() {
      // 역순이라 end 데이트가 기준 2달씩 조회
      // baseEndDate 2023-06-05
      // 1page: 2023-04-05 ~ 2023-06-05
      // 2page: 2023-02-04 ~ 2023-04-04
      // 3page: 2022-12-03 ~ 2023-02-03

      const endDate = this.$moment(this.baseEndDate).format()

      let startDate = this.$moment(endDate).subtract(2, 'month').format()
      // 2달을 뺐을때 시작일보다 클 수 없다
      if (this.$moment(startDate).isBefore(this.limitDates.limitStartDate)) {
        startDate = this.limitDates.limitStartDate
      }

      this.baseEndDate = this.$moment(startDate).add(-1, 'days')
      this.setSummarysBaseEndDate(this.baseEndDate)

      return {
        startDate,
        endDate,
      }
    },
    async loadSummarys() {
      if (this.summaryLoading || !this.isLoadable) {
        return
      }

      this.summaryLoading = true
      try {
        // 조회 기준일이 가장 오래된 날짜 이전이면 조회안함
        if (this.$moment(this.baseEndDate).isBefore(this.limitDates.limitStartDate)) {
          return
        }

        if (!this.hasStoredSummarys) {
          await this.getSummarys(this.getPageLimitDates())
        } else {
          await this.getSummarysAppend(this.getPageLimitDates())
        }
      } finally {
        this.summaryLoading = false
      }
    },
  },
  async created() {
    this.initLoading = true
    try {
      // LimitDates 조회 후 LimitDates를 가지고 Summarys 조회
      await Promise.all([this.getMe(), this.getLimitDates()])

      if (this.hasStoredSummarys) {
        this.baseEndDate = this.summarys?.baseEndDate
        return
      }

      // 조회 기준일 초기화
      this.baseEndDate = this.limitDates.limitEndDate
      await this.loadSummarys()
    } finally {
      this.initLoading = false
    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep .v-btn {
  &.white {
    border: solid $gray-30 1px !important;
    background-color: white;
  }

  &__loader {
    color: $gray-50 !important;
  }
}
</style>
